import HtmlElement from './HtmlElement';
import {$body} from "../Constants";

const Selector = {
	TEXT_ANIMATION: '.text-animation',
	TEXT_ANIMATION_TEXTS: '.text-animation-texts'
};

/**
 * TextAnimation
 *
 * @class
 * @augments HtmlElement
 */
class TextAnimation extends HtmlElement {
	onReady() {
		this.$element.find(Selector.TEXT_ANIMATION_TEXTS).each((i, el) => {
			$(el).teletype( {
				text: $(el).data('texts') || [],
				typeDelay: 0,
				backDelay: 20
			});
		});
	}
}

let allTextAnimations = [];

$body.find(Selector.TEXT_ANIMATION).each(function() {
	allTextAnimations.push(new TextAnimation($(this)));
});

export default allTextAnimations;